module.exports = __webpack_public_path__ + "img/for-you03.8e79a7f6.jpg";